<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="850px"
    scrollable
  >
    <v-card class="rounded-xl">

      <!-- Toolbar -->
      <v-toolbar
        color="primaryLight"
        dark
        flat
      >
        <v-toolbar-title class="text-h6 font-weight-medium">
          Filtros
        </v-toolbar-title>
      </v-toolbar>

      <!-- Contenido -->
      <v-card-text class="pt-6">
        <v-container>

          <v-row dense>
            <!-- Filtro por tipo de medio -->
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="localMedioTiposFiltered"
                :items="tiposMedioAereo"
                item-text="TIPO"
                item-value="ID_MEDIO_TIPO"
                label="Tipos de medio"
                multiple
                chips
                small-chips
                deletable-chips
                clearable
                outlined
                hide-details
              />
            </v-col>

            <!-- Filtro por incendio -->
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="localIncendiosFiltered"
                :items="incendiosReduced"
                :item-text="(item) => item.NOMBRE || item.LOCALIDAD"
                item-value="ID_INCENDIO"
                label="Incendios"
                multiple
                chips
                small-chips
                deletable-chips
                clearable
                outlined
                hide-details
              />
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>

      <!-- Acciones -->
      <v-card-actions class="px-6 pb-4">
        <v-spacer />

        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green darken-1" @click="aceptar">Aceptar</v-btn>

      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    show: Boolean,
    incendiosFiltered: Array,
    medioTiposFiltered: Array
  },

  data: () => ({
    localIncendiosFiltered: null,
    localMedioTiposFiltered: null
  }),

  computed: {
    ...mapGetters('incendio', ['incendiosReduced']),
    ...mapGetters('medio', ['tiposMedioAereo'])
  },

  mounted() {
    this.localIncendiosFiltered = this.incendiosFiltered
    this.localMedioTiposFiltered = this.medioTiposFiltered
  },

  methods: {
    cancelar() {
      this.$emit('cancelar')
    },
    aceptar() {
      const filtros = {
        medioTiposFiltered: this.localMedioTiposFiltered,
        incendiosFiltered: this.localIncendiosFiltered
      }
      this.$emit('aceptar', filtros)
    }
  }
}
</script>
